import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { NO_OF_REVIEWS_ON_PAGE } from 'apps/products/actions/reviews';
import Button from 'widgets/Button';

import QuantitiyInput from 'apps/quantityControls/components/QuantityInput';

export default class PaginationLight extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    totalCount: PropTypes.number.isRequired,
    fetchReviews: PropTypes.func.isRequired,
    setActivePage: PropTypes.func.isRequired,
    sku: PropTypes.string.isRequired,
    activePage: PropTypes.number,
    sortOrder: PropTypes.string,
  };

  numberOfPages = () => Math.ceil(this.props.totalCount / NO_OF_REVIEWS_ON_PAGE);

  generateNextButton = () => (
    <Button
      className="gn-button gn-button--secondary bop-reviews__paginationButton"
      key="next"
      disabled={this.props.activePage >= this.numberOfPages()}
      onClick={() => {
        this.changeActivePage(1);
      }}
      size="small"
    >
      <span className="icon icon__chevron-right" />
    </Button>);

  changeActivePage = (delta) => {
    this.props.fetchReviews(this.props.sku,
      (this.props.activePage + delta - 1) * NO_OF_REVIEWS_ON_PAGE,
      NO_OF_REVIEWS_ON_PAGE,
      this.props.sortOrder);
    this.props.setActivePage(delta);
  };

  generatePrevButton = () => {
    if (this.props.activePage === 1) {
      return null;
    }
    return (
      <Button
        className={
          `gn-button gn-button--secondary bop-reviews__paginationButton ${this.props.activePage > 1 ? 'active' : ''}`
        }
        key="prev"
        disabled={this.props.activePage === 1}
        onClick={() => {
          this.changeActivePage(-1);
        }}
        size="small"
      >
        <span className="icon icon__chevron-left " />
      </Button>);
  };

  render() {
    const { totalCount, activePage, className } = this.props;

    if (totalCount <= NO_OF_REVIEWS_ON_PAGE) {
      return null;
    }

    return (
      <div className={classNames('bop-reviews__paginationWrapper', className)}>
        {
          [this.generatePrevButton(),
            <QuantitiyInput
              quantity={activePage}
              onQuantitySubmit={(quantityDelta) => {
                this.changeActivePage(quantityDelta);
              }}
              key="input"
              maxQuantity={this.numberOfPages()}
              minQuantity={1}
              className="bop-reviews__paginationInput"
              showButtons={false}
            />,
            <p key="no-of-pages" className="bop-reviews__paginationText">of {this.numberOfPages()}</p>,
            this.generateNextButton()]}
      </div>
    );
  }
}
